/**
 * Shared predicate behind `showWhen` and `readonlyWhen`.
 *
 * A condition normally matches by value — a single value, or any value in an array. The
 * `'not-null'` sentinel matches instead on presence, so a field can react to "this has a value"
 * without naming every value it could hold. Blank is judged the same way cfi-record-view renders
 * an em dash: null, undefined and the empty string all count as absent.
 */

import type { FieldValue } from './cfi-record.model';

/** Matches any populated value rather than one specific value. */
export const NOT_NULL = 'not-null';

export function hasValue(value: FieldValue | undefined): boolean {
  return value != null && value !== '';
}

export function matchesCondition(value: FieldValue | undefined, is: FieldValue | FieldValue[]): boolean {
  if (is === NOT_NULL) {
    return hasValue(value);
  }

  // Compared as-is rather than normalising a missing control to null, so an existing
  // `is: [...]` rule keeps matching exactly what it matched before.
  return Array.isArray(is) ? is.includes(value as FieldValue) : value === is;
}
